"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTooltipValue = exports.StyledAttributeContainerCell = exports.StyledAttributeListContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledAttributeListContainer = styled_components_1.default.div `
  display: grid;
  grid-auto-columns: min-content;
  grid-auto-flow: column;
  row-gap: ${({ theme }) => theme.spacing(0.5)};
  column-gap: ${({ theme }) => theme.spacing(3)};

  .list-column {
    display: grid;
    grid-template-columns: 132px 132px;
    grid-auto-rows: min-content;
    row-gap: ${({ theme }) => theme.spacing(0.5)};
    column-gap: ${({ theme }) => theme.spacing(3)};
    align-items: center;
  }
`;
exports.StyledAttributeContainerCell = styled_components_1.default.div `
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  color: ${({ theme }) => theme.palette.text.primary};

  .attribute-value-box {
    overflow: hidden;
    max-width: 132px;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: ${({ theme }) => theme.palette.text.secondary};

    .attribute-text {
      font-weight: 400;
    }
  }

  .attribute-icon {
    display: flex;
    font-size: 0.875rem;
    min-width: 1em;
    height: 1em;

    & svg {
      font-size: inherit;
      fill: none;
    }
  }

  .attribute-text {
    font-size: 0.875rem;
    font-weight: 700;
    overflow: hidden;
    max-width: 132px;
    white-space: nowrap;
    text-overflow: ellipsis;

    &--crossed-out {
      text-decoration: line-through;
    }
  }
`;
exports.StyledTooltipValue = styled_components_1.default.div `
  .attribute-text {
    font-size: 0.875rem;
    font-weight: 400;

    &--crossed-out {
      text-decoration: line-through;
    }
  }
`;
